import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function CrearSolicitud_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "CrearSolicitud",
    rutaEndPoint: "/EnterpriseServices/Sel/Solicitud/crearSolicitud",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface CrearSolicitud_Entrada {
  ListaLlaves: ListaLlaves;
  NombreCorporativo: string;
  DetallesSolicitudDeServicio: DetallesSolicitudDeServicio;
  SISTEMA: string;
}

export function builtCrearSolicitud_Entrada(
  p_ListaLlaves: ListaLlaves,
  p_NombreCorporativo: string,
  p_DetallesSolicitudDeServicio: DetallesSolicitudDeServicio,
  p_SISTEMA: string
) {
  var retorno: CrearSolicitud_Entrada = {
    ListaLlaves: p_ListaLlaves,
    NombreCorporativo: p_NombreCorporativo,
    DetallesSolicitudDeServicio: p_DetallesSolicitudDeServicio,
    SISTEMA: p_SISTEMA,
  };

  return retorno;
}

export interface DetallesSolicitudDeServicio {
  Area: string;
  NombreSuscriptor: string;
  DatosFiscales: DatosFiscales;
  Descripcion: string;
  TipoCuenta: string;
  Direccion: Direccion;
  InfoPPE: InfoPPE;
  SubArea: string;
  MailConfirmacion: string;
  Pais: string;
}

export function builtDetallesSolicitudDeServicio(
  p_Area: string,
  p_NombreSuscriptor: string,
  p_DatosFiscales: DatosFiscales,
  p_Descripcion: string,
  p_TipoCuenta: string,
  p_Direccion: Direccion,
  p_InfoPPE: InfoPPE,
  p_SubArea: string,
  p_MailConfirmacion: string,
  p_Pais: string
) {
  var retorno: DetallesSolicitudDeServicio = {
    Area: p_Area,
    NombreSuscriptor: p_NombreSuscriptor,
    DatosFiscales: p_DatosFiscales,
    Descripcion: p_Descripcion,
    TipoCuenta: p_TipoCuenta,
    Direccion: p_Direccion,
    InfoPPE: p_InfoPPE,
    SubArea: p_SubArea,
    MailConfirmacion: p_MailConfirmacion,
    Pais: p_Pais,
  };

  return retorno;
}

export interface DatosFiscales {
  UsoCfdi: string;
  TipoFactura: string;
  MetodoEnvio: string;
  RegimenFiscal: string;
  RazonSocial: string;
  TipoPersona: string;
  RFC: string;
  Compania: string;
}

export function builtDatosFiscales(
  p_UsoCfdi: string,
  p_TipoFactura: string,
  p_MetodoEnvio: string,
  p_RegimenFiscal: string,
  p_RazonSocial: string,
  p_TipoPersona: string,
  p_RFC: string,
  p_Compania: string
) {
  var retorno: DatosFiscales = {
    UsoCfdi: p_UsoCfdi,
    TipoFactura: p_TipoFactura,
    MetodoEnvio: p_MetodoEnvio,
    RegimenFiscal: p_RegimenFiscal,
    RazonSocial: p_RazonSocial,
    TipoPersona: p_TipoPersona,
    RFC: p_RFC,
    Compania: p_Compania,
  };

  return retorno;
}

export interface Direccion {
  DelMun: string;
  NoInt: string;
  Poblacion: string;
  Colonia: string;
  Calle: string;
  CP: string;
  NoExt: string;
  Estado: string;
}

export function builtDireccion(
  p_DelMun: string,
  p_NoInt: string,
  p_Poblacion: string,
  p_Colonia: string,
  p_Calle: string,
  p_CP: string,
  p_NoExt: string,
  p_Estado: string
) {
  var retorno: Direccion = {
    DelMun: p_DelMun,
    NoInt: p_NoInt,
    Poblacion: p_Poblacion,
    Colonia: p_Colonia,
    Calle: p_Calle,
    CP: p_CP,
    NoExt: p_NoExt,
    Estado: p_Estado,
  };

  return retorno;
}

export interface InfoPPE {
  FechaExpiracion: string;
  providerEventId: string;
  orderType: string;
  FechaInicio: string;
  NombreDelEvento: string;
  Costo: string;
  Canal: string;
  TipoEvento: string;
  MailFechaTermino: string;
  TokenOverride: string;
  TokenValue: string;
  MailFechaInicio: string;
  Duracion: string;
  SKYTrackingId: string;
  CanalDisplay: string;
  IDEvento: string;
  ZonaHoraria: string;
  ppvGenreId: string;
}

export function builtInfoPPE(
  p_FechaExpiracion: string,
  p_providerEventId: string,
  p_orderType: string,
  p_FechaInicio: string,
  p_NombreDelEvento: string,
  p_Costo: string,
  p_Canal: string,
  p_TipoEvento: string,
  p_MailFechaTermino: string,
  p_TokenOverride: string,
  p_TokenValue: string,
  p_MailFechaInicio: string,
  p_Duracion: string,
  p_SKYTrackingId: string,
  p_CanalDisplay: string,
  p_IDEvento: string,
  p_ZonaHoraria: string,
  p_ppvGenreId: string
) {
  var retorno: InfoPPE = {
    FechaExpiracion: p_FechaExpiracion,
    providerEventId: p_providerEventId,
    orderType: p_orderType,
    FechaInicio: p_FechaInicio,
    NombreDelEvento: p_NombreDelEvento,
    Costo: p_Costo,
    Canal: p_Canal,
    TipoEvento: p_TipoEvento,
    MailFechaTermino: p_MailFechaTermino,
    TokenOverride: p_TokenOverride,
    TokenValue: p_TokenValue,
    MailFechaInicio: p_MailFechaInicio,
    Duracion: p_Duracion,
    SKYTrackingId: p_SKYTrackingId,
    CanalDisplay: p_CanalDisplay,
    IDEvento: p_IDEvento,
    ZonaHoraria: p_ZonaHoraria,
    ppvGenreId: p_ppvGenreId,
  };

  return retorno;
}

export interface ListaLlaves {
  Llave: Llave[];
}

export function builtListaLlaves(p_Llave: Llave[]) {
  var retorno: ListaLlaves = {
    Llave: p_Llave,
  };

  return retorno;
}

export interface Llave {
  NumeroLlave: string;
}

export function builtLlave(p_NumeroLlave: string) {
  var retorno: Llave = {
    NumeroLlave: p_NumeroLlave,
  };

  return retorno;
}

//SALIDA

export interface CrearSolicitud_Salida {
  resultado: string;
  resultadodesc: string;
}

export type CrearSolicitud_Respuesta = CrearSolicitud_Salida;
